<ng-container *transloco="let t">
  @if (isFacade()) {
    <div class="support-chat" tooltip="{{ tooltipText }}" placement="bottom">
      <button
        class="btn btn-lg btn-icon-only btn-outline-secondary bg-transparent border-0"
        [attr.aria-label]="t('components.supportChat.ariaLabel')"
        (mouseover)="isSalesforceEnabled ? initSalesforce() : initFreshchat()"
        (click)="removeFacade()"
      >
        <i class="modus-icons text-white notranslate" aria-hidden="true" icon
          >chat</i
        >
      </button>
    </div>
  } @else {
    <div class="support-chat" tooltip="{{ tooltipText }}" placement="bottom">
      <button
        class="btn btn-lg btn-icon-only btn-outline-secondary bg-transparent border-0"
        [attr.aria-label]="t('components.supportChat.ariaLabel')"
        [disabled]="disabled()"
        (click)="toggleShowChat()"
      >
        <i class="modus-icons text-white notranslate" aria-hidden="true" icon
          >chat</i
        >
      </button>
    </div>
  }
</ng-container>
